export default {"src":"/_next/static/media/logo-color-white.6efc5649.svg","height":254,"width":1646};